import { themeColorSet, ThemedText, ThemedView } from "@app/theme"
import { formatIndianCurrency } from "@app/utils/utility";
import { CheckCircle,WarningCircle } from "@app/sharedComponents/Icons/Icons";

const DSPPaymentBreakup = ({interestDetails,shortFallDetails,selectedAmount,chargesDue,principalOutStandingAmount}:any)=>{
    
    const {outstandingInterest = 0,month} = interestDetails;


    const paymentBreakdown = {
        interestPayment: 0,
        remainingInterest: 0,
        chargesPayment: 0,
        remainingCharges: 0,
        principalPayment: 0,
        remainingPrincipal: 0,
        showPrincipalPayment: false,
        showChargesPayment: false,
        isShortfallSettled: false,
        remainingShortfall: 0
    };

    let tempVal = selectedAmount;

    if(tempVal > outstandingInterest){
        paymentBreakdown.interestPayment = outstandingInterest;
        if(chargesDue !== undefined) paymentBreakdown.showChargesPayment = true;
        tempVal = tempVal - outstandingInterest;
        paymentBreakdown.remainingInterest = 0;
    } else {
        paymentBreakdown.interestPayment = tempVal; 
        paymentBreakdown.remainingInterest = outstandingInterest - tempVal;
        tempVal = 0;
    }

    if(tempVal > chargesDue){
        paymentBreakdown.showPrincipalPayment = true;
        paymentBreakdown.chargesPayment = chargesDue;
        paymentBreakdown.remainingCharges = 0;
        tempVal = tempVal - chargesDue;
        paymentBreakdown.principalPayment = tempVal;
    } else {
        paymentBreakdown.chargesPayment = tempVal;
        paymentBreakdown.remainingCharges = chargesDue - tempVal;
        tempVal = 0;
    }
    paymentBreakdown.remainingPrincipal = principalOutStandingAmount - tempVal;
    if(tempVal > 0) paymentBreakdown.showPrincipalPayment = true;
    if(tempVal >= shortFallDetails?.shortfallAmount){
        paymentBreakdown.isShortfallSettled = true;
    } else {
        paymentBreakdown.remainingShortfall = shortFallDetails?.shortfallAmount - tempVal;
        paymentBreakdown.isShortfallSettled = false;
    }

    const {interestPayment,remainingInterest,showChargesPayment,chargesPayment,remainingCharges,showPrincipalPayment,principalPayment,remainingPrincipal,isShortfallSettled,remainingShortfall} = paymentBreakdown;
    const isShortfallDue = shortFallDetails?.shortfallAmount > 0;
    
    return (
        <ThemedView px="md" pb="md" borderBottomLeftRadius="sm" borderBottomRightRadius="sm"  backgroundColor="bg-fill-primary">
            {outstandingInterest > 0 && <ThemedView mt="md">
                <ThemedView flexDirection="row" justifyContent="space-between">
                    <ThemedText variant="b3s" color="text-primary">
                        Towards interest due for {month}
                    </ThemedText>
                    <ThemedText variant="b3s" color="text-primary">
                        ₹{formatIndianCurrency(interestPayment)}
                    </ThemedText>
                </ThemedView>
                <ThemedText variant="b4r" color="text-secondary">
                    Remaining balance: ₹{formatIndianCurrency(remainingInterest)}
                </ThemedText>
            </ThemedView>}
            {chargesDue > 0 && <ThemedView mt="md">
                <ThemedView flexDirection="row" justifyContent="space-between">
                    <ThemedText variant="b3s" color="text-primary">
                        Towards charges due
                    </ThemedText>
                    <ThemedText variant="b3s" color="text-primary">
                        ₹{formatIndianCurrency(chargesPayment)}
                    </ThemedText>
                </ThemedView>
                <ThemedText variant="b4r" color="text-secondary">
                    Remaining balance: ₹{formatIndianCurrency(remainingCharges)}
                </ThemedText>
            </ThemedView>}
            {principalPayment > 0 && <ThemedView mt="md">
                <ThemedView flexDirection="row" justifyContent="space-between">
                    <ThemedText variant="b3s" color="text-primary">
                        Outstanding amount
                    </ThemedText>
                    <ThemedText variant="b3s" color="text-primary">
                        ₹{formatIndianCurrency(principalPayment)}
                    </ThemedText>
                </ThemedView>
                <ThemedText variant="b4r" color="text-secondary">
                    Remaining balance: ₹{formatIndianCurrency(remainingPrincipal)}
                </ThemedText>
            </ThemedView>}
            {isShortfallDue && (
            <ThemedView backgroundColor={isShortfallSettled ? "bg-fill-emphasis-secondary" :"bg-fill-error"}  mt="md" borderRadius="sm" alignItems="center" flexDirection="row" flex={1} flexWrap="wrap" px="md" py="sm">
                {isShortfallSettled ? 
                <CheckCircle  weight="fill" color={themeColorSet["icon-success"]}/> :
                <WarningCircle  weight="fill" color={themeColorSet["icon-error"]} /> 
                }
                <ThemedView flexDirection="row" ml="md">
                    <ThemedText variant="b4r" color="text-primary">
                        Shortfall amount of 
                    </ThemedText>
                    <ThemedText variant="b4b" color="text-primary">
                        {isShortfallSettled ? ` ₹${Number(shortFallDetails?.shortfallAmount)}` : ` ₹${Number(remainingShortfall).toFixed(2)}`}
                    </ThemedText>
                    <ThemedText variant="b4r" color="text-primary">
                        {isShortfallSettled ? ' will be settled' : ' is remaining'}
                    </ThemedText>
                </ThemedView>
            </ThemedView>
        )}
        </ThemedView>
    )
}

export default DSPPaymentBreakup;
